import { Link } from '@trussworks/react-uswds';

/**
 * Reusable link component with many options to style and transform.
 *
 * @param {object} props
 * @param {string} props.href
 * @param {string} [props.title]
 * @param {React.ReactNode} [props.content]
 * @param {React.ReactNode} [props.children]
 */

const ExternalLink = ({ children, content, href, title, ...customProps }) => (
  <Link
    href={href}
    rel='noreferrer'
    tabIndex={0}
    target='_blank'
    title={title ?? undefined}
    variant='external'
    {...customProps}
  >
    {content ?? children ?? href}
  </Link>
);

export default ExternalLink;
